import { render, staticRenderFns } from "./CustomerProperty.vue?vue&type=template&id=537052fc&scoped=true"
import script from "./CustomerProperty.vue?vue&type=script&lang=js"
export * from "./CustomerProperty.vue?vue&type=script&lang=js"
import style0 from "./CustomerProperty.vue?vue&type=style&index=0&id=537052fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537052fc",
  null
  
)

export default component.exports